if (typeof WDN == "undefined") var WDN = {};
typeof WDN.CarCollection == "undefined" &&
    (WDN.CarCollection = (function () {
        var r = {},
            i = function (t, e, o) {
                (this.parent = t),
                    (this.selector = this.parent.querySelector('select[data-id="'.concat(e, '"]'))),
                    (this.output = this.parent.querySelector("select[data-id='".concat(o, "']"))),
                    (this.outputParent = this.parent.querySelector(".Custom__properties-select[data-id='".concat(o, "']"))),
                    (this.labelList = this.parent.querySelectorAll(".Custom__properties-label_value")),
                    (this.id = e),
                    this.start();
            },
            n = { parent: ".Custom__properties" },
            s = function (t, e) {
                var o = document.querySelector("".concat(n.parent));
                o && (r[t] = new i(o, t, e));
            };
        return (
            (i.prototype.start = function () {
                this.bind();
            }),
            (i.prototype.updateActive = function () {
                this.active = this.selector.options[this.selector.selectedIndex].value;
            }),
            (i.prototype.bind = function () {
                this.selector.addEventListener("change", this.update.bind(this));
            }),
            (i.prototype.update = function () {
                this.updateActive(),
                    (this.models = Models.filter(function (t) {
                        if (t.Brand === this.active) return t;
                    }, this)[0]),
                    this.updateLabel(),
                    this.render();
            }),
            (i.prototype.updateLabel = function () {
                this.labelList.forEach(function (t) {
                    t.innerHTML = this.active;
                }, this),
                    (this.output.name = "properties[".concat(this.active, " Model]"));
            }),
            (i.prototype.render = function () {
                var t = this.models.Models.split(/[,]+/);
                (this.output.innerHTML = ""), this.outputParent.classList.remove("Hide"), (this.output.innerHTML += '<option value="" disabled selected>'.concat(Translations.choose_one, "</option>"));
                for (var e = 0; e < t.length; e++) this.output.innerHTML += '<option value="'.concat(t[e], '">').concat(t[e], "</option>");
            }),
            { Create: s }
        );
    })()),
    WDN.CarCollection.Create("brand", "model");

  (function () {
    if (window.__carDetailsBuyNowValidation) return;
    window.__carDetailsBuyNowValidation = true;

    var fieldSelector = 'select[name="properties[Car Make]"], select[data-id="model"], select[name="properties[Car Year]"]';

    document.addEventListener('change', function (event) {
      if (!event.target.matches(fieldSelector) || !event.target.value) return;
      event.target.classList.remove('invalid');
      event.target.removeAttribute('aria-invalid');
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      var button = target && target.closest ? target.closest('.shopify-payment-button__button') : null;
      if (!button) return;

      var form = button.closest('form');
      if (!form) return;

      var fields = Array.prototype.slice.call(form.querySelectorAll(fieldSelector));
      var invalidFields = fields.filter(function (field) {
        return !field.value || !field.checkValidity();
      });

      fields.forEach(function (field) {
        var invalid = invalidFields.indexOf(field) !== -1;
        field.classList.toggle('invalid', invalid);
        if (invalid) {
          field.setAttribute('aria-invalid', 'true');
        } else {
          field.removeAttribute('aria-invalid');
        }
      });

      if (!invalidFields.length) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      invalidFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      invalidFields[0].focus({ preventScroll: true });
      invalidFields[0].reportValidity();
    }, true);
  })();
